import React from 'react'
import './commonlist.scss'
const CommonList = ({ Heading , list }) => {
  return (
    <div className='common-list'>
      <div className='heading'>
        <h3>{Heading}</h3>
      </div>
      <div className="content-col">
        <div className="text">
          <ol>
            {list.map((feature, index) => (
              <li key={index}>
                <p>{feature}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </div>
  )
}

export default CommonList